import { resolveColor, type ColorRef } from './color';
import { semantic, type ThemedColor } from './semantic';

export type Theme = 'light' | 'dark';

const isThemed = (v: unknown): v is ThemedColor =>
  typeof v === 'object' && v !== null && 'light' in v && 'dark' in v;

/** Every semantic color as `[dottedPath, ThemedColor]`, in declaration order. */
export function flattenSemantic(
  node: object = semantic,
  prefix = '',
): Array<[string, ThemedColor]> {
  return Object.entries(node).flatMap(([key, value]) => {
    const path = prefix ? `${prefix}.${key}` : key;
    return isThemed(value)
      ? [[path, value] as [string, ThemedColor]]
      : flattenSemantic(value as object, path);
  });
}

const byPath = new Map(flattenSemantic());

/** Resolve a semantic path (or `=primitive.ref`) to a hex value for the given theme. */
export function resolveSemantic(path: string, theme: Theme): string {
  if (path.startsWith('=')) return resolveColor(path.slice(1) as ColorRef);
  const entry = byPath.get(path);
  if (!entry) throw new Error(`Unknown semantic color: ${path}`);
  return resolveColor(entry[theme]);
}
